<script setup lang="ts">
import SiteEditableText from '../../SiteEditableText.vue'
import SiteImageAttribution from '../../SiteImageAttribution.vue'
import SiteLink from '../../SiteLink.vue'
import type { AboutBlock } from '../../types'

defineProps<{ block: AboutBlock }>()
</script>

<template>
  <section :id="block.settings.anchorId" class="site:bg-(--site-color-surface) site:py-10 site:@min-[40rem]:py-16">
    <div class="site-site-container site:overflow-hidden site:bg-(--site-color-text) site:text-(--site-color-primary-text) site:shadow-(--site-shadow-md)" :style="{ borderRadius: 'var(--site-radius-lg)' }">
      <div class="site:grid site:@min-[64rem]:grid-cols-[1.2fr_0.8fr]">
        <div class="site:p-7 site:@min-[40rem]:p-12 site:@min-[64rem]:p-16">
          <SiteEditableText v-if="block.content.eyebrow" v-model="block.content.eyebrow" as="p" class="site:text-sm site:font-semibold site:text-(--site-color-accent)" />
          <SiteEditableText v-model="block.content.heading" as="h2" class="site-heading site:mt-3 site:text-3xl site:font-bold site:tracking-tight site:@min-[40rem]:text-5xl" />
          <SiteEditableText v-model="block.content.description" as="p" class="site:mt-6 site:max-w-2xl site:text-lg site:leading-8 site:opacity-75" />
          <SiteEditableText v-if="block.content.secondaryDescription" v-model="block.content.secondaryDescription" as="p" class="site:mt-4 site:max-w-2xl site:leading-7 site:opacity-70" />
          <SiteLink v-if="block.content.action" :link="block.content.action" class="site-site-button site:mt-8">
            {{ block.content.action.label }}
          </SiteLink>
        </div>

        <div class="site:flex site:flex-col site:bg-(--site-color-primary) site:p-7 site:@min-[40rem]:p-10">
          <figure
            v-if="block.content.image"
            class="site:relative site:aspect-[4/3] site:w-full site:overflow-hidden"
            :style="{ borderRadius: 'var(--site-radius-md)' }"
          >
            <img :src="block.content.image.src" :alt="block.content.image.alt" class="site:h-full site:w-full site:object-cover" loading="lazy" />
            <SiteImageAttribution v-if="block.content.image.attribution" :image="block.content.image" class="site:absolute site:bottom-2 site:right-2" />
          </figure>
          <dl v-if="block.content.facts?.length" class="site:mt-auto site:grid site:grid-cols-2 site:gap-5 site:pt-8">
            <div v-for="fact in block.content.facts" :key="fact.id">
              <SiteEditableText v-model="fact.value" as="dt" class="site-heading site:text-2xl site:font-bold" />
              <SiteEditableText v-model="fact.label" as="dd" class="site:mt-1 site:text-sm site:opacity-75" />
            </div>
          </dl>
        </div>
      </div>
    </div>
  </section>
</template>
